import { Button, Icon, Input, InputProps } from "@ttc3k/trekker";
import { Search, Xmark } from "iconoir-react";
import { Box } from "styled-system/jsx";

type SearchInputProps = InputProps & {
  onClearSearch?: () => void;
};

export const SearchInput = ({ onClearSearch, ...props }: SearchInputProps) => {
  const isSearching =
    props.value && typeof props.value === "string" && props.value.length > 0;
  return (
    <Box w={"full"} position={"relative"}>
      <Input pr={"400"} {...props} />
      <Button
        visual={"unstyled"}
        onClick={isSearching ? onClearSearch : undefined}
      >
        <Icon
          Element={isSearching ? Xmark : Search}
          size={"sm"}
          position={"absolute"}
          top={"16px"}
          right={"150"}
          color={"icon.mid"}
          strokeWidth={1.75}
        />
      </Button>
    </Box>
  );
};
